/** Defines the React context for the global search bar (GoBar) state. */
import { createContext } from 'react';

export const GoBarContext = createContext(null);
